<template>
  <div>
    <div class="form-group form-group-default"
         :class="{ 'required': required }">
      <label>{{ label }}</label>
      <input v-model="internalValue"
             v-validate="validationRules"
             :data-vv-as="validationTranslation"
             :name="fieldName"
             :id="fieldId"
             :type="fieldType"
             :disabled="disabled"
             class="form-control"
             @keypress="$emit('keypress', $event)"
             @paste="$emit('paste', $event)"
             @input="$emit('input', $event.target.value)">
    </div>
    <transition name="slide-fade">
      <label v-show="hasError"
             :id="errorId"
             class="error"
             :for="fieldId">
        {{ errors.first(fieldId) }}
      </label>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  inject: ['$validator'],
  props: {
    label: String,
    value: String,
    fieldName: String,
    fieldId: String,
    fieldType: String,
    validationRules: String,
    validationTranslation: String,
    required: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value: function(value) {
      this.internalValue = value
    },
  },
  computed: {
    hasError() {
      return this.errors.has(this.fieldId)
    },
    errorId() {
      return `${this.fieldId}-error`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/form/InputText.vue